import { BUTTON_VARIANTS } from "@cdkglobal/radial";
import { StyledConfirmationDialog } from "../../../../../utils/styled";
import { useIntl } from "react-intl";
import { messages } from "../messages";
export default function CopyPOUnitsOfMeasureConfirmationDialog({
  isConfirmationDialogOpen,
  handleConfirm,
  handleCancel,
}: Readonly<{
  isConfirmationDialogOpen: boolean;
  handleConfirm: () => void;
  handleCancel: () => void;
}>): JSX.Element {
  const intl = useIntl();
  return (
    <div>
      <StyledConfirmationDialog
        buttonsProps={[
          {
            id: "confirmation-dialog-cancel",
            onClick: handleCancel,
            text: intl.formatMessage({
              id: "button.no",
              defaultMessage: "No",
            }),
            variant: BUTTON_VARIANTS.TEXT,
          },
          {
            id: "confirmation-dialog-ok",
            onClick: handleConfirm,
            text: intl.formatMessage({
              id: "button.yes",
              defaultMessage: "Yes",
            }),
            variant: BUTTON_VARIANTS.PRIMARY,
          },
        ]}
        id="confirmation-dialog"
        dataTestId="po-uom-confirmation-dialog"
        isOpen={isConfirmationDialogOpen}
        onClose={handleCancel}
        title={intl.formatMessage({
          id: "title.confirmAction",
          defaultMessage: "Confirm Action",
        })}
      >
        {intl.formatMessage(messages.copyUOM)}
      </StyledConfirmationDialog>
    </div>
  );
}
